import { UserSite } from './userSite';

export class User {
    /* The user unique identifier */
    _id: string = '';

    /* The game name */
    _username: string = 'No username';

    /* The avatar */
    _avatar: string = '';

    /* The email */
    _email?: string = '';

    /* First access date */
    _firstAccess: Date = new Date();

    /* Last access date */
    _lastAccess: Date = new Date();

    get id(): string {
        return this._id;
    }

    get username(): string {
        return this._username;
    }

    get avatar(): string {
        return this._avatar;
    }

    get email(): string | undefined {
        return this._email;
    }

    get firstAccess(): Date {
        return this._firstAccess;
    }

    get lastAccess(): Date {
        return this._lastAccess;
    }
}

export class ClientUser extends User {
    /* The firstname */
    _firstname: string = '';

    /* The lastname */
    _lastname: string = '';

    /* The cover image */
    _cover: string = '';

    /* The email */
    _sites: { [sideID: string]: UserSite } = {};

    /* Version du test A/B d'inscription tirée à la création du profil (utils/signupFlow), si connue. */
    _signupFlow?: string;

    get signupFlow(): string | undefined {
        return this._signupFlow;
    }

    get firstname(): string {
        return this._firstname;
    }

    get lastname(): string {
        return this._lastname;
    }

    get cover(): string {
        return this._cover;
    }

    getNumSites(): number {
        return this.getSiteIDs().length;
    }

    getSiteIDs(): Array<string> {
        return Object.keys(this._sites);
    }
}
